import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { initAxios } from 'utils/axios';

export type PaginatedResponse<T> = {
  data: T[];
  meta: {
    totalCount: number;
    cursor: string;
    hasMore?: boolean;
  };
  links: { next: string };
};

export interface IBaseApi<T, C> {
  getById(id: string): Promise<T>;
  getList(config?: C): Promise<PaginatedResponse<T>>;
  getByIds(ids: string[]): Promise<T[]>;
}

export default abstract class BaseApi<T>
  implements IBaseApi<T, AxiosRequestConfig>
{
  protected readonly axiosInstance: AxiosInstance;

  constructor(
    url: string,
    service?: 'dt' | 'projects' | 'cognota-be' | 'agent'
  ) {
    this.axiosInstance = initAxios(url, service);
  }

  async getById(id: string): Promise<T> {
    const { data } = await this.axiosInstance.get<T>(id);
    return data;
  }

  async getList(config?: AxiosRequestConfig): Promise<PaginatedResponse<T>> {
    const { data } = await this.axiosInstance.get<PaginatedResponse<T>>(
      '',
      config
    );

    return data;
  }

  async getByIds(ids: string[]): Promise<T[]> {
    const { data } = await this.axiosInstance.get<T[]>('', {
      params: { ids: ids.join(',') },
    });
    return data;
  }

  async delete(id: string): Promise<void> {
    await this.axiosInstance.delete(id);
  }

  async update(id: string, payload: Partial<T>): Promise<T> {
    const { data } = await this.axiosInstance.put<T>(id, payload);
    return data;
  }

  async getByIdsPost(
    params: Record<string, string[] | number | string | undefined>
  ): Promise<PaginatedResponse<T>> {
    const { data } = await this.axiosInstance.post<PaginatedResponse<T>>(
      '',
      params
    );
    return data;
  }
}
